<template>
    <div>
        <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>
</template>
<script>
import URL from "@/api/api";
export default {
    data(){
        return{
            name:this.$route.query.name,
            linkUrl:this.$route.query.linkUrl,
            type:this.$route.query.type
        }
    },
    mounted(){
        let data={
            openid:localStorage.getItem('openid') ? localStorage.getItem('openid') : localStorage.getItem('openidC'),
            name:this.name
        }
        if(this.type==1){
            this.$fetchPost(URL.isLink.url,data).then((res) => {
              if(res.data.code==20000){
                window.location.href=this.linkUrl
              }
            });
        }
    }
}
</script>
<style lang="less" scoped>
.van-loading{
    top: 100px;
}

</style>